import themeGlobal from './themeGlobal';
import UtilObject from '../utils/UtilObject';
import {
  adminLayoutDarkTokens,
  createAdminCardComponentTheme,
  createAdminLayoutComponentTheme,
} from './adminLayoutTheme';
import { authDarkTokens } from './authTheme';
import { appDarkPalette } from './themePalette';

const themeDarkConfigLocal = {
  token: {
    ...adminLayoutDarkTokens,
    ...authDarkTokens,
    colorBgContainer: appDarkPalette.surfaceElevatedBg,
    colorBgElevated: appDarkPalette.surfaceElevatedBg,
    colorBorder: appDarkPalette.border,
    colorBorderSecondary: appDarkPalette.borderSoft,
    colorFillQuaternary: appDarkPalette.surfaceBgAlt,
    colorText: appDarkPalette.text,
    colorTextSecondary: appDarkPalette.textSecondary,
    colorTextTertiary: appDarkPalette.textSecondary,
    colorTextPlaceholder: '#7f8da3',
    colorBgContainerDisabled: appDarkPalette.disabledBg,
    colorBorderDisabled: appDarkPalette.disabledBorder,
    colorTextDisabled: appDarkPalette.disabledText,
  },
  components: {
    ...createAdminLayoutComponentTheme(adminLayoutDarkTokens),
    Card: createAdminCardComponentTheme(appDarkPalette),
    Input: {
      colorBgContainer: appDarkPalette.controlBg,
      hoverBg: appDarkPalette.controlBg,
      activeBg: appDarkPalette.controlBg,
      colorErrorBg: appDarkPalette.controlBg,
      colorBorder: appDarkPalette.border,
      hoverBorderColor: appDarkPalette.primary,
      activeBorderColor: appDarkPalette.primary,
      activeShadow: '0 0 0 3px rgba(96, 165, 250, 0.16)',
      colorBgContainerDisabled: appDarkPalette.disabledBg,
      colorTextDisabled: appDarkPalette.disabledText,
    },
    InputNumber: {
      colorBgContainer: appDarkPalette.controlBg,
      colorErrorBg: appDarkPalette.controlBg,
      colorBgContainerDisabled: appDarkPalette.disabledBg,
      colorTextDisabled: appDarkPalette.disabledText,
    },
    Select: {
      selectorBg: appDarkPalette.controlBg,
      clearBg: appDarkPalette.controlBg,
      colorBgContainer: appDarkPalette.controlBg,
      colorErrorBg: appDarkPalette.controlBg,
      colorBorder: appDarkPalette.border,
      hoverBorderColor: appDarkPalette.primary,
      activeBorderColor: appDarkPalette.primary,
      activeOutlineColor: 'rgba(96, 165, 250, 0.16)',
      optionActiveBg: appDarkPalette.itemHoverBg,
      optionSelectedBg: appDarkPalette.primarySoftBg,
      colorBgContainerDisabled: appDarkPalette.disabledBg,
      colorTextDisabled: appDarkPalette.disabledText,
    },
    DatePicker: {
      colorBgContainerDisabled: appDarkPalette.disabledBg,
      colorTextDisabled: appDarkPalette.disabledText,
    },
    Segmented: {
      trackBg: appDarkPalette.surfaceElevatedBg,
      itemColor: appDarkPalette.textSecondary,
      itemHoverColor: appDarkPalette.text,
      itemHoverBg: appDarkPalette.itemHoverBg,
      itemSelectedBg: appDarkPalette.primarySoftBg,
      itemActiveBg: appDarkPalette.primarySoftBgAlt,
      itemSelectedColor: appDarkPalette.text,
    },
  },
};

const themeDarkConfig = UtilObject.deepMerge(themeGlobal, themeDarkConfigLocal);

export default themeDarkConfig;
